// @flow
import type {EsimProductActionType, SimResourceType} from './actions';

const initialState: EsimProductStateType = {
  simResource: null,
  price: 0,
  chooseEsimRouteName: '',
  isEsimCompatible: false,
  eSimSelected: false,
};

export const eSimProductReducer = (
  state: EsimProductStateType = initialState,
  action: EsimProductActionType,
) => {
  switch (action.type) {
    case 'FETCH_AVAILABLE_SIM_SUCCESS':
      return {
        ...state,
        simResource: action.payload.simResource,
      };
    case 'SET_SIM_RESOURCE':
      return {
        ...state,
        simResource: action.payload.simResource,
      };
    case 'GET_ESIM_PRODUCT_PRICE_SUCCESS':
      return {
        ...state,
        price: action.payload.price,
      };

    case 'GET_CHOOSE_ESIM_ROUTENAME_SUCCESS':
      return {
        ...state,
        chooseEsimRouteName: action.payload.chooseEsimRouteName,
      };

    case 'SET_ESIM_COMPATIBLE':
      return {
        ...state,
        isEsimCompatible: action.payload.isEsimCompatible,
      };

    case 'ESIM_SELECTED_SUCCESS':
      return {
        ...state,
        eSimSelected: action.payload.eSimSelected,
      };

    default:
      return state;
  }
};

export type EsimProductStateType = {
  simResource: ?SimResourceType,
  price: number,
  chooseEsimRouteName: string,
  isEsimCompatible: Boolean,
  eSimSelected: Boolean,
};
